// ── CardConnect Commerce configuration ──────────────────────────────
// Swap in your real booking calendar URL (Calendly, Cal.com, etc.).
// Every "Book My Free Savings Review" button on the site uses this.
export const BOOKING_URL = "https://calendly.com/your-calendar-link";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const isRealBookingUrl =
  /^https?:\/\//.test(BOOKING_URL) && !BOOKING_URL.includes("your-calendar-link");

// Real legal pages on the client domain (verified to exist)
export const PRIVACY_POLICY_URL = "https://cardconnectcommerce.com/privacy-policy/";
export const TERMS_URL = "https://cardconnectcommerce.com/terms-and-conditions/";

// Rate floor: projected rates never go below this effective rate (percent).
// Protects against quoting below estimated interchange/network costs.
export const RATE_FLOOR_PCT = 1.8;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

// Every primary CTA leads here: scroll to the hero form and focus it.
export const scrollToForm = () => {
  scrollToId("hero-form");
  setTimeout(() => {
    document.querySelector("[data-testid='hero-name-input']")?.focus({ preventScroll: true });
  }, 900);
};
